import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=29eaa5a4"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=29eaa5a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports